export const ENVIRONMENTS = ['hmg', 'prd', 'dev', 'local'];
export const CUSTOM_EVENT_ANALYTICS = 'custom_event_analytics';
